<template>
  <div id="page-content" tabindex="-1">
    <span aria-label="Confirm Reservation Page" aria-live="polite" role="contentinfo"></span>
    <h2 class="public-h5 font-weight-bold mt-5 mb-5"
    :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.confirmReservationPageHeader }}
    </h2>
    <v-card>
      <v-card-text class="centerContainer">
        <reservation-details 
          ref="ReservationDetails"
          :booking="booking"
          :show-barcode="true"
          :show-map-link="true"
          :show-service-type-link="true"
          :footer-text="siteText.ui.viewMessageText"
          :show-print-link="true"
          :isRTL="isRTLLanguage"
          >
        </reservation-details>
      </v-card-text>
    </v-card>
    <p></p>
    <div class="text-left pt-4">
      <v-layout row wrap>
      <v-flex md3>
        <v-btn
          class="ma-2 dmv-btn"
          height="45px"
          width="260px"
          @click="home()">
          {{ siteText.ui.confirmReservationHome }}
        </v-btn>
      </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import ReservationDetails from '../components/ReservationDetails.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ConfirmReservationPage',
  components: {
    ReservationDetails,
  },
  methods: {
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    home() {
      this.$emit('navigateTo', 'WelcomePage');
    },
    print() {
      console.log('Inside print of ConfirmReservationPage');
      this.$refs.ReservationDetails.Printer();
    },
},
  computed: {
    ...mapGetters(['siteText']),
    ...mapGetters(['booking', 'isRTLLanguage'])
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
